import { render, staticRenderFns } from "./trackTip.vue?vue&type=template&id=2c487028&scoped=true&"
import script from "./trackTip.vue?vue&type=script&lang=js&"
export * from "./trackTip.vue?vue&type=script&lang=js&"
import style0 from "./trackTip.vue?vue&type=style&index=0&id=2c487028&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c487028",
  null
  
)

export default component.exports